import { Modal } from "react-bootstrap";

import { useProposalDocument } from "./proposalDocumentsContext";

const PreviewModal: React.FC = () => {
  const { showModal, setShowModal, iframeUrl } = useProposalDocument();
  return (
    <Modal
      show={showModal}
      size="xl"
      onHide={() => {
        setShowModal(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Document Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div style={{ height: "90vh", overflowY: "auto" }}>
          <iframe
            src={iframeUrl}
            title="Document Preview"
            style={{ width: "100%", height: "100vh", border: "none" }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PreviewModal;
